import { createElement } from 'react';
import { node, oneOf } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import { Caption } from './styled.js';

var TableCaption = function TableCaption(_ref) {
  var children = _ref.children,
      position = _ref.position,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "position"]);

  return createElement(Caption, _extends({
    use: "caption",
    position: position
  }, props), children);
};

var tableCaptionPropTypes = {
  children: node.isRequired,
  position: oneOf(['top', 'bottom'])
};
TableCaption.propTypes = tableCaptionPropTypes;
var tableCaptionDefaultProps = {
  position: 'top'
};
TableCaption.defaultProps = tableCaptionDefaultProps;
var C = TableCaption;
export default C;
export { TableCaption, tableCaptionDefaultProps, tableCaptionPropTypes };